import { forwardRef } from 'react';

import { Button, ButtonProps, cn } from '@growtherapy/sprout-ui';

/**
 * A light wrapper around `Button` which tailors its appearance to match the
 * size of the `ToastCloseButton` with size "sm".
 */
export const ToastButton = forwardRef<HTMLButtonElement, Omit<ButtonProps, 'size'>>(function ToastButton(
  { className, ...props },
  ref,
) {
  return <Button ref={ref} className={cn('whitespace-nowrap max-h-[2.25rem]', className)} size='sm' {...props} />;
});
